module.exports = __webpack_public_path__ + "static/media/20201216_204409_024_IMG_3224.28573275.jpg";